import { LogLevel } from '@environment/enums/log-level.enum';
import { captureSentryMessage } from '@shared/sentry';

export async function reloadChromeRuntimeIfPossible(): Promise<void> {
  captureSentryMessage('Attempting to reload Chrome runtime if possible');
  const { isUpdateAvailable, idleState } = await chrome.storage.local.get(['isUpdateAvailable', 'idleState']);
  captureSentryMessage(`Reload conditions ${isUpdateAvailable}:${idleState}`, {}, LogLevel.Info, {
    isUpdateAvailable,
    idleState,
  });
  if (!isUpdateAvailable || !idleState || idleState === 'active') {
    captureSentryMessage('Conditions not met for reloading');
    return;
  }
  // TODO support force reload for new version
  captureSentryMessage('Reloading Chrome runtime');
  chrome.runtime.reload();
}
